import React, { useState, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useCompanyInfo } from '../../pages/settings/hooks/useCompanyInfo';

export const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  
  // Call useCompanyInfo to load company settings on mount
  useCompanyInfo();

  return (
    <div className="min-h-screen bg-[#F7F3EC] font-sans text-[#1A1A1A] selection:bg-[#C91D25] selection:text-white">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <Header sidebarCollapsed={collapsed} />
      <main className={`transition-all duration-300 pt-[72px] ${collapsed ? 'ml-16' : 'ml-[260px]'}`}>
        <div className="px-2 pt-2 pb-2 max-w-[1600px] mx-auto animate-fade-in">
          {children}
        </div>
      </main>
    </div>
  );
};




